<template>
  <div
    class="menu-navigation-list p-bottom-m-1"
    data-animate="preloader-opacity"
  >
    <ul class="flex is-justify-center hide-for-small">
      <li v-for="menuCategory in menuCategories" :key="menuCategory.id">
        <NuxtLink
          data-no-cursor
          :to="
            localePath({
              name: 'piatti-e-vini-category',
              params: {
                category: menuCategory.slug,
              },
            })
          "
          class="text-sans-caption is-text-uppercase is-bold"
          :class="{
            'link-underline-1 --active':
              menuCategory.slug === route.params.category,
            'link-underline-reverse-1':
              menuCategory.slug !== route.params.category,
          }"
        >
          <span>{{ menuCategory.name }}</span>
        </NuxtLink>
      </li>
    </ul>

    <div class="show-for-small row-40-25 menu-navigation-list-back">
      <NuxtLink
        data-no-cursor
        :to="
          localePath({
            name: 'piatti-e-vini',
            hash: '#menulist',
          })
        "
        class="text-sans-s"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="31.598"
          height="18.309"
          viewBox="0 0 31.598 18.309"
          :alt="props.label"
        >
          <defs>
            <clipPath id="clip-path">
              <rect
                id="Rettangolo_669"
                data-name="Rettangolo 669"
                width="31.598"
                height="18.309"
                transform="translate(61.72 -1)"
                fill="#5c5743"
              />
            </clipPath>
          </defs>
          <g
            id="freccia"
            transform="translate(-61.72 1)"
            clip-path="url(#clip-path)"
          >
            <path
              id="Tracciato_292"
              data-name="Tracciato 292"
              d="M98.754,3.483A9.018,9.018,0,0,1,97.881,0H95.813A9.022,9.022,0,0,0,96.7,3.572a7.717,7.717,0,0,0,2.57,2.495c.271.171-.292-.131,0,0H0V8.023H99.272c-.292.133.27-.174,0,0a7.673,7.673,0,0,0-2.559,2.495,9.071,9.071,0,0,0-.889,3.564h2.069a9.018,9.018,0,0,1,.872-3.483c.964-2.1,3.1-2.667,5.41-2.575V6.067c-2.309.092-4.446-.483-5.41-2.584"
              transform="translate(-10.843 1.112)"
              fill="#5c5743"
            />
          </g>
        </svg>
        <span>{{ $t('cta.backToMenus') }}</span>
      </NuxtLink>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagesMenuNavigationList',
}
</script>

<script setup>
const route = useRoute()
const touch = ref(false)

const props = defineProps({
  menuCategories: {
    type: Array,
    default: () => [],
  },
})

onMounted(() => {
  touch.value = 'ontouchstart' in window || !!navigator.maxTouchPoints
})
</script>

<style lang="scss">
@import './style.scss';
</style>
